import { render } from "./QualityGroupDetails.vue?vue&type=template&id=368d5eda"
import script from "./QualityGroupDetails.vue?vue&type=script&lang=js"
export * from "./QualityGroupDetails.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/components/views/agro_exporter/quality_control/container/show_inspect/quality_group_details.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fquality_control%2Fcontainer%2Fshow_inspect%2FQualityGroupDetails.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__